export default "__VITE_ASSET__8d6fc5b1__$_?component__"